/** Default preference values — Energy 0.5 / Distance 5 mi / Price $$. */
export const DEFAULT_TASTE_PREFERENCES = {
    energy: 0.5,
    maxDistanceMiles: 5,
    maxPrice: 2,
};
